<div class="boxes-area boxes-style-two bg-f5f7fa" style="min-height: calc(100vh - 220px);">
  <div class="container">
    <div class="section-title">
      <h2>Thông tin cá nhân</h2>
    </div>
  </div>
  <div class="container">
    <div class="sv-data-view-area">
      <div class="sv-data-view-area__main-block">
        <div class="grid">
          <div class="col-12 md:col-6">
            <p-card header="Thông tin cá nhân">
              <div class="sv-form-container">
                <form #formElement [formGroup]="formGroup">
                  <div class="grid p-fluid">
                    <div class="col-12">
                      <validation-summary #validationSummary [formElement]="formElement" [formGroup]="formGroup">
                      </validation-summary>
                    </div>
                    <div class="col-12 md:col-12">
                      <div class="field -required -error">
                        <label>{{'Users.userName' | translate}}</label>
                        <input pInputText type="text" class="sv-text-field" [(ngModel)]="itemDetail.userName"
                          formControlName="userName" [disabled]="true">
                      </div>
                    </div>
                    <div class="col-12 md:col-12">
                      <div class="field -required -error">
                        <label>{{'Users.displayName' | translate}}</label>
                        <input pInputText type="text" class="sv-text-field" [(ngModel)]="itemDetail.displayName"
                          formControlName="displayName">
                      </div>
                    </div>
                    <div class="col-12 md:col-12">
                      <div class="field -required -error">
                        <label>{{'Users.email' | translate}}</label>
                        <input pInputText type="text" class="sv-text-field" [(ngModel)]="itemDetail.email"
                          formControlName="email">
                      </div>
                    </div>
                  </div>
                </form>
              </div>
              <div class="ui-dialog-footer">
                <div class="grid sv-modal-footer-content">
                  <div class="col-8 fl">
                  </div>
                  <div class="col-4 fr">
                    <button pButton type="button" (click)="save()" label="{{'BUTTON.SAVE' | translate}}"
                      icon="ci ci-save">
                    </button>
                  </div>
                </div>
              </div>
            </p-card>

          </div>
          <div class="col-12 md:col-6">
            <p-card header="Đổi mật khẩu">
              <div class="sv-form-container">
                <form #formElement [formGroup]="formGroup1">
                  <div class="grid p-fluid">
                    <div class="col-12">
                      <validation-summary #validationSummary [formElement]="formElement1" [formGroup]="formGroup1">
                      </validation-summary>
                    </div>
                    <div class="col-12">
                      <div class="field -required -error">
                        <label>{{'USERINFO.OLDPASSWORD' | translate}}</label>
                        <input pInputText type="password" class="sv-text-field" [(ngModel)]="itemDetail.oldPassword"
                          formControlName="oldPassword">
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="field -required -error">
                        <label>{{'USERINFO.NEWPASSWORD' | translate}}</label>
                        <input pInputText type="password" class="sv-text-field" [(ngModel)]="itemDetail.newPassword"
                          formControlName="newPassword">
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="field -required -error">
                        <label>{{'USERINFO.RENEWPASSWORD' | translate}}</label>
                        <input pInputText type="password" class="sv-text-field" [(ngModel)]="itemDetail.confirmPassword"
                          formControlName="confirmPassword">
                      </div>
                    </div>
                  </div>
                </form>
              </div>
              <div class="ui-dialog-footer">
                <div class="grid sv-modal-footer-content">
                  <div class="col-8 fl">
                  </div>
                  <div class="col-4 fr">
                    <button pButton type="button" (click)="onChangePass()"
                      label="{{'USERINFO.BTNCHAGEPASS' | translate}}" icon="ci ci-save">
                    </button>
                  </div>
                </div>
              </div>
            </p-card>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>
